import algoliaApi from '../services/algolia-api';

export default {
  network: algoliaApi.getNetworkFilterOptions,
  studio: algoliaApi.getStudioFilterOptions,
  show: algoliaApi.getShowFilterOptions,
  movie: algoliaApi.getMovieFilterOptions,
  title: algoliaApi.getTitleFilterOptions,
  platform: algoliaApi.getPlatformFilterOptions
};
